import { ComparaisonOperator } from '../../Enums/comparaison-operator';
import { DataType } from '../../Enums/data-type';

/**
 * Remarks : Les propriétés de cette classe sont en PascalCase car coté API il s'agit d'un dynamic qui lorsqu'il est sérialisé
 * n'applique pas la transformation des noms de propriété en CamelCase.
 */
export class VariableApiConditionDatas {
    public DataType: DataType;
    public VariableName: string;
    public Value: string;
    public Operator: ComparaisonOperator;
}
